import _slicedToArray from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "C:/Users/Marie/Desktop/2022/april_MARIE_DOT_IE/apis/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { isArray } from 'vega';
import { isBinParams } from '../bin';
import { isConditionalDef, isFieldDef, isScaleFieldDef } from '../channeldef';
import { normalizeLogicalComposition } from '../logical';
import { SpecMapper } from '../spec/map';
import { isBin, isFilter, isLookup } from '../transform';
import { duplicate, entries, vals } from '../util';
export var SelectionCompatibilityNormalizer = /*#__PURE__*/function (_SpecMapper) {
  _inherits(SelectionCompatibilityNormalizer, _SpecMapper);

  var _super = _createSuper(SelectionCompatibilityNormalizer);

  function SelectionCompatibilityNormalizer() {
    _classCallCheck(this, SelectionCompatibilityNormalizer);

    return _super.apply(this, arguments);
  }

  _createClass(SelectionCompatibilityNormalizer, [{
    key: "map",
    value: function map(spec, normParams) {
      var _a, _b;

      (_a = normParams.emptySelections) !== null && _a !== void 0 ? _a : normParams.emptySelections = {};
      (_b = normParams.selectionPredicates) !== null && _b !== void 0 ? _b : normParams.selectionPredicates = {};
      spec = normalizeTransforms(spec, normParams);
      return _get(_getPrototypeOf(SelectionCompatibilityNormalizer.prototype), "map", this).call(this, spec, normParams);
    }
  }, {
    key: "mapLayerOrUnit",
    value: function mapLayerOrUnit(spec, normParams) {
      spec = normalizeTransforms(spec, normParams);

      if (spec.encoding) {
        var encoding = {};

        var _iterator = _createForOfIteratorHelper(entries(spec.encoding)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                channel = _step$value[0],
                enc = _step$value[1];

            encoding[channel] = normalizeChannelDef(enc, normParams);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        spec = Object.assign(Object.assign({}, spec), {
          encoding: encoding
        });
      }

      return _get(_getPrototypeOf(SelectionCompatibilityNormalizer.prototype), "mapLayerOrUnit", this).call(this, spec, normParams);
    }
  }, {
    key: "mapUnit",
    value: function mapUnit(spec, normParams) {
      var _a = spec,
          selection = _a.selection,
          rest = __rest(_a, ["selection"]);

      if (selection) {
        return Object.assign(Object.assign({}, rest), {
          params: entries(selection).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                name = _ref2[0],
                selDef = _ref2[1];

            var _a;

            var _b = selDef,
                value = _b.init,
                bind = _b.bind,
                empty = _b.empty,
                select = __rest(_b, ["init", "bind", "empty"]);

            if (select.type === 'single') {
              select.type = 'point';
              select.toggle = false;
            } else if (select.type === 'multi') {
              select.type = 'point';
            } // Propagate emptiness forwards and backwards


            normParams.emptySelections[name] = empty !== 'none';

            var _iterator2 = _createForOfIteratorHelper(vals((_a = normParams.selectionPredicates[name]) !== null && _a !== void 0 ? _a : {})),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var pred = _step2.value;
                pred.empty = empty !== 'none';
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }

            return {
              name: name,
              value: value,
              select: select,
              bind: bind
            };
          })
        });
      }

      return spec;
    }
  }]);

  return SelectionCompatibilityNormalizer;
}(SpecMapper);

function normalizeTransforms(spec, normParams) {
  var tx = spec.transform,
      rest = __rest(spec, ["transform"]);

  if (tx) {
    var transform = tx.map(function (t) {
      if (isFilter(t)) {
        return {
          filter: normalizePredicate(t, normParams)
        };
      } else if (isBin(t) && isBinParams(t.bin)) {
        return Object.assign(Object.assign({}, t), {
          bin: normalizeBinExtent(t.bin)
        });
      } else if (isLookup(t)) {
        var _a = t.from,
            param = _a.selection,
            from = __rest(_a, ["selection"]);

        return param ? Object.assign(Object.assign({}, t), {
          from: Object.assign({
            param: param
          }, from)
        }) : t;
      }

      return t;
    });
    return Object.assign(Object.assign({}, rest), {
      transform: transform
    });
  }

  return spec;
}

function normalizeChannelDef(obj, normParams) {
  var _a, _b;

  var enc = duplicate(obj);

  if (isFieldDef(enc) && isBinParams(enc.bin)) {
    enc.bin = normalizeBinExtent(enc.bin);
  }

  if (isScaleFieldDef(enc) && ((_b = (_a = enc.scale) === null || _a === void 0 ? void 0 : _a.domain) === null || _b === void 0 ? void 0 : _b.selection)) {
    var _c = enc.scale.domain,
        param = _c.selection,
        domain = __rest(_c, ["selection"]);

    enc.scale.domain = Object.assign(Object.assign({}, domain), param ? {
      param: param
    } : {});
  }

  if (isConditionalDef(enc)) {
    if (isArray(enc.condition)) {
      enc.condition = enc.condition.map(function (c) {
        var selection = c.selection,
            param = c.param,
            test = c.test,
            cond = __rest(c, ["selection", "param", "test"]);

        return param ? c : Object.assign(Object.assign({}, cond), {
          test: normalizePredicate(c, normParams)
        });
      });
    } else {
      var _d = normalizeChannelDef(enc.condition, normParams),
          selection = _d.selection,
          _param = _d.param,
          test = _d.test,
          cond = __rest(_d, ["selection", "param", "test"]);

      enc.condition = _param ? enc.condition : Object.assign(Object.assign({}, cond), {
        test: normalizePredicate(enc.condition, normParams)
      });
    }
  }

  return enc;
}

function normalizeBinExtent(bin) {
  var ext = bin.extent;

  if (ext === null || ext === void 0 ? void 0 : ext.selection) {
    var param = ext.selection,
        rest = __rest(ext, ["selection"]);

    return Object.assign(Object.assign({}, bin), {
      extent: Object.assign(Object.assign({}, rest), {
        param: param
      })
    });
  }

  return bin;
}

function normalizePredicate(op, normParams) {
  // Normalize old compositions of selection names (e.g., selection: {and: ["one", "two"]})
  var normalizeSelectionComposition = function normalizeSelectionComposition(o) {
    return normalizeLogicalComposition(o, function (param) {
      var _a, _b;

      var _c;

      var empty = (_a = normParams.emptySelections[param]) !== null && _a !== void 0 ? _a : true;
      var pred = {
        param: param,
        empty: empty
      };
      (_b = (_c = normParams.selectionPredicates)[param]) !== null && _b !== void 0 ? _b : _c[param] = [];
      normParams.selectionPredicates[param].push(pred);
      return pred;
    });
  };

  return op.selection ? normalizeSelectionComposition(op.selection) : normalizeLogicalComposition(op.test || op.filter, function (o) {
    return o.selection ? normalizeSelectionComposition(o.selection) : o;
  });
}